import completeReports from "./ReportsTestValues";

export class ReportsBase {
  constructor(dataStore) {
    this.dataStore = dataStore
  }

  // Returns a promise
  retrieve() {
    return this.dataStore.retrieve()
  }

  // Returns a promise
  retrieveTest() {
    return new Promise((resolve, reject) => {
      resolve(completeReports)
    })
  }
}

export default ReportsBase